var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-generic',{attrs:{"module":_vm.path,"title":"Roles","headers":_vm.headers,"form-fields":_vm.formRoles,"select-info":_vm.selectInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }